import React, {useEffect} from 'react';
import {observer} from "mobx-react";
import {Space, Typography} from "antd";
import {useTranslate} from "../../hooks/translate.hook";
import {ComponentPropsFromRoute} from "../../routers/routers";
import {useLocation} from "react-router-dom";
import {useNavigate} from "react-router";
import {RouteButtons} from "../common/route-tabs/route.buttons";

interface ErrorsProps extends ComponentPropsFromRoute {}
export const Errors: React.FC<ErrorsProps> = observer(({routeChildren}) => {
    const t = useTranslate();
    const navigate = useNavigate();
    const {pathname} = useLocation();

    useEffect(() => {
        if (pathname === "/errors") {
            navigate("/errors/logger")
        }
    },[pathname]);

    return (
        <Space direction="vertical" size={[0, 0]}>
                <Typography.Title level={3}>
                    {t("LOGGER.TITLE")}
                </Typography.Title>
                <RouteButtons routes={routeChildren!}/>
        </Space>
    );
});
